import { IGrupos } from '../../interface';
import { useGrupo } from '../../hooks/useGrupos';
import { useEffect } from 'react';
import { useGrupoContext } from '../../context/GroupContext';
import { Modal, Form, Input, Button, Spin } from 'antd';

interface IModalGrupoProps {
    hook: ReturnType<typeof useGrupo>;
    onCreatedGrupo?: (grupo: IGrupos) => void;
}

export const ModalGrupo = ({ hook, onCreatedGrupo }: IModalGrupoProps) => {
    const [formGrupo] = Form.useForm();

    const {
        editingData,
        isGrupoOpen,
        fecharModalGrupo,
    } = useGrupoContext();

    const {
        createGrupo,
        updateGrupo,
        loadingGrupoModal,
    } = hook;

    useEffect(() => {
        if (isGrupoOpen && editingData) {
            formGrupo.setFieldsValue({
                nome: editingData.nome,
            });
        } else if (isGrupoOpen && !editingData) {
            formGrupo.resetFields();
        }
    }, [isGrupoOpen, editingData, formGrupo]);

    const handleFinish = async (values: { nome: string }) => {
        if (editingData?.id) {
            await updateGrupo(editingData.id, values.nome);
        } else {
            const novoGrupo = await createGrupo(values.nome);
            if (novoGrupo) {
                onCreatedGrupo?.(novoGrupo);
            }
        }

        formGrupo.resetFields();
        fecharModalGrupo();
    };

    return (
        <Modal
            title={editingData ? 'Editar Grupo' : 'Novo Grupo'}
            open={isGrupoOpen}
            onCancel={fecharModalGrupo}
            onOk={() => formGrupo.submit()}
            zIndex={1100}
            footer={[
                <Button key="back" onClick={fecharModalGrupo}>
                    Fechar
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    disabled={loadingGrupoModal}
                    style={{ backgroundColor: '#008000', borderColor: '#008000' }}
                    onClick={() => formGrupo.submit()}
                >
                    {editingData ? 'Atualizar' : 'Salvar'}
                </Button>
            ]}
        >
            <Spin spinning={loadingGrupoModal}>
                <Form
                    form={formGrupo}
                    layout="vertical"
                    onFinish={handleFinish}
                    preserve={false}
                >
                    <Form.Item
                        name="nome"
                        label="Nome do Grupo"
                        rules={[{ required: true, message: 'Por favor, insira o nome do grupo' }]}
                    >
                        <Input placeholder="Digite o nome do grupo" />
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    );
};
